/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityGovernanceFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return SecurityGovernanceFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<SecurityGovernanceFeatureFlagsWithDefaults>): SecurityGovernanceFeatureFlagsWithDefaults {
        let obj = Object.assign(new SecurityGovernanceFeatureFlagsWithDefaults(), model);
        SecurityGovernanceFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityGovernanceFeatureFlagsWithDefaults>): SecurityGovernanceFeatureFlagsWithDefaults {
        if (!model) return null;
        return SecurityGovernanceFeatureFlagsWithDefaults.newInstance(<SecurityGovernanceFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityGovernanceFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.SecurityGovernanceFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityGovernanceFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SecurityGovernanceFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    segn_2601_b_security_issues_trend: boolean = true;

    /**
     * Flag's default value
     */
    segn_2602_a_resource_detail_view: boolean = true;

    /**
     * Flag's default value
     */
    segn_2602_a_application_with_bcs_questions: boolean = true;

    /**
     * Flag's default value
     */
    segn_2603_a_application_to_workload: boolean = true;

    /**
     * Flag's default value
     */
    segn_2603_a_attackpath_analysis: boolean = true;

}
